import { useEffect, useState } from 'react';
import { Product } from '@pizza-hut-us-development/client-core';
import { PIZZA_RECIPE_PAGE_VIEW } from '@/menu/pizza/constants';
import useAnalytics from '@/dataAnalytics/hooks/useAnalytics';
import { useApplicationInitialized } from '@/hooks/useApplicationInitialized';
import { getMenuItems, onMenuInitialLoadAnalytics } from '@/dataAnalytics/dataAnalyticsHelper';
import { IsCyo, MenuRecipe } from '@/menu/pizza/pizzaMenuTypes';
import { getOrInitializeOptimizely } from '../../../../optimizely/optimizely';
import { isCyo } from '../utils/pizzaCategories';

export function usePizzaMenuPageViewAnalytics(
  cyoPizza: Product | undefined,
  tavernPizzas: Product[],
  signaturePizzas: Product[],
  isLoading: boolean
): void {
  const analytics = useAnalytics();
  const [pageLoadAnalyticsPushed, setPageLoadAnalyticsPushed] = useState(false);
  const appInitialized = useApplicationInitialized();
  const optimizelyInstance = getOrInitializeOptimizely();
  const pageView = PIZZA_RECIPE_PAGE_VIEW;
  const label = 'Pizza';

  useEffect(() => {
    if (!isLoading && appInitialized && !pageLoadAnalyticsPushed) {
      const pizzaMenuRecipeItems = (
        [cyoPizza, ...tavernPizzas, ...signaturePizzas]
          .filter(Boolean)
          .map((item, index) => ({
            ...item,
            priority: index,
            isCYO: item && isCyo(item) ? IsCyo.TRUE : IsCyo.FALSE
          })) as MenuRecipe[]
      );
      const items = getMenuItems(pizzaMenuRecipeItems, label);
      analytics.push(() => onMenuInitialLoadAnalytics(label, items));

      optimizelyInstance?.track(pageView);
      setPageLoadAnalyticsPushed(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageLoadAnalyticsPushed, appInitialized, cyoPizza, tavernPizzas, signaturePizzas, isLoading]);
}
